import React from 'react';
import clsx from 'clsx';
import { Colors, FontSize, FontWeight } from '@common/tokens';
import { Collapse as AntCollapse, CollapseProps } from 'antd';
import { Animation, Icon } from '@common/components';

type Props = {
  textSize?: 'sm' | 'md' | 'lg';
} & CollapseProps;

const FONT_SIZE_MAP = {
  sm: FontSize.xs,
  md: FontSize.sm,
  lg: FontSize.md,
};

const defaultExpandIcon: CollapseProps['expandIcon'] = ({ isActive }) => (
  <div>
    <Animation active={!!isActive} kind="rotate-right" rotationDegree={90}>
      <Icon icon="angleRight" kind="light" color="elm" />
    </Animation>
  </div>
);

/**
 * Legacy Collapse — thin wrapper around AntD's `Collapse`.
 *
 * @deprecated Use `Collapse` from `@common/components` (AntD-free) instead. This
 * wrapper is retained only so existing usages keep their exact behavior while we
 * migrate off AntD.
 */
export function DeprecatedCollapse({
  className,
  style,
  textSize = 'md',
  expandIcon,
  ...props
}: Props) {
  return (
    <>
      <AntCollapse
        {...props}
        className={clsx('wk-collapse', className)}
        expandIcon={expandIcon ?? defaultExpandIcon}
        ghost
        style={{
          ...style,
          fontSize: FONT_SIZE_MAP[textSize],
        }}
      />
      <style jsx>{`
        :global(.wk-collapse > .ant-collapse-item > .ant-collapse-header) {
          color: ${Colors.elm};
          cursor: pointer;
          font-size: ${FontSize.md};
          font-weight: ${FontWeight.medium};
        }
        :global(.wk-collapse .wk-icon) {
          margin-top: 3px;
          margin-bottom: -3px;
        }
      `}</style>
    </>
  );
}

DeprecatedCollapse.Panel = AntCollapse.Panel;
